<!-- Пункт перехода к складскому учёту компании. -->
<template>
  <li
    v-if="visible"
    class="nav-item"
    :class="{ active: $route.name === 'Warehouse' }"
    role="button"
    tabindex="0"
    :title="collapsed ? 'Склад' : ''"
    @click="open"
    @keydown.enter.prevent="open"
    @keydown.space.prevent="open"
  >
    <div class="link-icon_box warehouse-icon">
      <AppIcon name="cargo" :size="24" stroke="var(--color-green)" />
    </div>
    <span v-if="!collapsed" class="nav-link">Склад</span>
  </li>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "AppSidebarWarehouseItem",

  components: {
    AppIcon,
  },

  props: {
    collapsed: Boolean,
    canSeePage: {
      type: Function,
      required: true,
    },
  },

  computed: {
    visible() {
      return this.canSeePage("warehouses");
    },
  },

  methods: {
    open() {
      this.$router.push({ name: "Warehouse" });
    },
  },
};
</script>

<style scoped>
.warehouse-icon :deep(path) {
  fill: none !important;
  stroke: var(--color-green) !important;
}
</style>
